
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetJianchaJianyanList,
  AddJianchaJianyanList,
  EditJianchaJianyanList,
  DelJianchaJianyanList,
  GetKnowledgeList,
  GetKnowledgeDetail,
  DelKnowledge,
  EditKnowledge,
  GetZidian,
} from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private ifShowEdit: any = false;
  private editData: any = {};
  private window: any = window;
  private data: any[] = [];
  private types: any = [];
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  private getType(type: any, key: any) {
    const params: any = {
      data_type: type,
    };
    GetZidian(this, params).then((res: any) => {
      this[key] = res[type];
    });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["inspect_name"]) {
      this.$message.warning("请输入检验项目名称！");
      return;
    }
    if (!this.editData["category"]) {
      this.$message.warning("请选择类别！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      temp_id: this.editData.temp_id,
      inspect_type: "checkup",
      category: this.editData["category"],
      inspect_name: this.editData["inspect_name"],
      desc: this.editData["desc"],
    };
    if (!this.editData.temp_id) {
      AddJianchaJianyanList(this, params).then((res: any) => {
        loading.close();
        this.$message.success("新增成功");
        this.ifShowEdit = false;
        this.getList();
      });
    } else {
      EditJianchaJianyanList(this, params).then((res: any) => {
        loading.close();
        this.$message.success("编辑成功");
        this.ifShowEdit = false;
        this.getList();
      });
    }
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any, index: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          temp_id: item.temp_id,
        },
      };
      DelJianchaJianyanList(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("删除成功");
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        inspect_type: "checkup",
        category: this.filters["类别"],
        inspect_name: this.filters.search,
        current_page: this.filters.current_page,
        page_count: this.filters.page_count,
      },
    };
    localStorage.setItem("jianyankuFilter", JSON.stringify(this.filters));
    GetJianchaJianyanList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "创建时间";
    this.filters.sort_value = 1;
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("jianchakuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("jianchakuFilter") as any);
    }
    this.getList();
  }
}
